/**
 * Submit feedback (bug / feature request) — sends email via server.
 */

import { API_BASE } from '../config/apiBase';

export async function submitFeedback(form: {
  userId: number;
  kind: 'bug' | 'request';
  subject: string;
  description: string;
  files: File[];
}): Promise<void> {
  const body = new FormData();
  body.append('userId', String(form.userId));
  body.append('kind', form.kind);
  body.append('subject', form.subject.trim());
  body.append('description', form.description.trim());
  for (const file of form.files) {
    body.append('files', file);
  }
  const res = await fetch(`${API_BASE}/api/feedback`, {
    method: 'POST',
    body,
  });
  const data = (await res.json().catch(() => ({}))) as { error?: string };
  if (!res.ok) {
    throw new Error(data.error || 'Failed to send feedback.');
  }
}
